<div class="title">О лиге</div>
<div class="league-content">
  <div [innerHTML]="league.about | safe: 'html'"></div>
</div>
